import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FAFAFA]" data-testid="protected-loading">
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-neutral-300 border-t-black" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Force new users through the welcome flow (except on the welcome page itself)
  if (
    user.onboarding_step &&
    user.onboarding_step !== "done" &&
    location.pathname !== "/welcome" &&
    location.pathname !== "/brand-voice" &&
    location.pathname !== "/admin"
  ) {
    return <Navigate to="/welcome" replace />;
  }

  return children;
}
